module.exports = __webpack_public_path__ + "img/w10-b3.adf7ac0d.jpg";